<div class="container-fluid">
  <button type="button" class="goback mb-2" (click)="goToList()">
    <i class="bi bi-arrow-left"></i> Bulk Breakup List
  </button>
  <div class="card">
    <div class="card-header bg-light">
      <h5 class="mb-0">• Repack Entry</h5>
    </div>

    <div class="card-body">
      <form [formGroup]="repackForm">
        <!-- Header Information -->
        <div class="row">
          <div class="col-md-2">
            <label class="form-label">Select Bulk Product SKU</label>
            <ng-select [items]="products" bindLabel="sku" bindValue="id" [typeahead]="skuSearch$"
              (search)="searchProductBySKU($event.term)" placeholder="Search by SKU" formControlName="bulkProduct"
              [readonly]="viewOnly" (change)="onProductSelectionChange($event, 'sku')">
            </ng-select>
          </div>
          <div class="col-md-2">
            <label class="form-label">Select Bulk Product EAN</label>
            <ng-select [items]="products" bindLabel="eanLabel" bindValue="id" [typeahead]="eanSearch$"
              (search)="searchProductByEAN($event.term)" placeholder="Search by EAN" formControlName="bulkProduct"
              [readonly]="viewOnly" (change)="onProductSelectionChange($event, 'ean')">
              <ng-template ng-option-tmp let-item="item">
                <div class="d-flex flex-column">
                  <span class="fw-bold">{{ item.eanLabel }}</span>
                  <small class="text-muted">{{ item.sku }} - {{ item.displayLabel }}</small>
                </div>
              </ng-template>
            </ng-select>
          </div>
          <div class="col-md-2">
            <label class="form-label">Select Bulk Product Name</label>
            <ng-select [items]="products" bindLabel="displayLabel" bindValue="id" [typeahead]="nameSearch$"
              (search)="searchProductByName($event.term)" placeholder="Search by Product Name"
              formControlName="bulkProduct" [readonly]="viewOnly" (change)="onProductSelectionChange($event, 'name')">
            </ng-select>
          </div>
          <div class="col-md-2">
            <label for="issueDate" class="form-label">Issue Date</label>
            <input type="date" id="issueDate" class="form-control" formControlName="date" [readOnly]="viewOnly" />
          </div>
          <div class="col-md-2">
            <label for="issueNo" class="form-label">Issue No</label>
            <input type="text" class="form-control" placeholder="auto" readonly />
          </div>
          <div class="col-md-2">
            <label class="form-label">Repack Number</label>
            <input type="text" id="repackNo" class="form-control" formControlName="jobNumber" readonly
              placeholder="Auto-generated" />
          </div>

          <div class="col-md-2">
            <label class="form-label">Wastage %</label>
            <input type="number" class="form-control" formControlName="wastagePercentage"
              placeholder="Enter wastage percentage" [readOnly]="viewOnly" />`
          </div>
        </div>
      </form>
      <!-- Main Content Area -->
      <div class="row mt-3">
        <!-- Left Side - Main Entry Table -->
        <div class="col-md-8">
          <div class="table-responsive mb-2">
            <table class="table table-bordered">
              <thead class="table-light">
                <tr>
                  <th>SKU Code</th>
                  <th>Item Name</th>
                  <th>Unit</th>
                  <th>Quantity</th>
                  <th>Cost Price</th>
                  <th>Selling Price</th>
                  <th>MRP</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                @for (item of childProducts; track item; let i = $index) {
                <tr>
                  <td>
                    @if (!viewOnly) {
                      <span class="text-primary" style="cursor: pointer; text-decoration: underline"
                        (click)="openNewPricingForm(item)"
                        title="Add new MRP / Selling Price for this SKU">
                        {{ item.sku }}
                      </span>
                    } @else {
                      {{ item.sku }}
                    }
                  </td>
                  <td>
                    {{ displayName(item) }}
                  </td>
                  <td>{{ item.variants?.[0]?.weight }} {{ item.uom }}</td>
                  <td class="text-center" style="width: 100px">
                    <input type="number" class="form-control form-control-sm" [(ngModel)]="item.quantity"
                      (ngModelChange)="updatePackedTotals()" [min]="1" required [readOnly]="viewOnly" />
                  </td>
                  <td>
                    @if (!viewOnly) {
                    <select class="form-select form-select-sm" [(ngModel)]="item.costPrice">
                      @for (option of item.variants?.[0]?.pricing || []; track option) {
                      <option [value]="option?.costPrice">
                        {{ option.costPrice }}
                      </option>
                      }
                    </select>
                    } @else {
                    {{ item.costPrice }}
                    }
                  </td>
                  <td>
                    @if (!viewOnly) {
                    <select class="form-select form-select-sm" [(ngModel)]="item.sellingPrice">
                      @for (option of item.variants?.[0]?.pricing || []; track option) {
                      <option [value]="option.sellingPrice">
                        {{ option.sellingPrice }}
                      </option>
                      }
                    </select>
                    } @else {
                    {{ item.sellingPrice }}
                    }
                  </td>
                  <td>
                    @if (!viewOnly) {
                    <select class="form-select form-select-sm" [(ngModel)]="item.mrp">
                      @for (option of item.variants?.[0]?.pricing || []; track option) {
                      <option [value]="option.mrp">
                        {{ option.mrp }}
                      </option>
                      }
                    </select>
                    } @else {
                    {{ item.mrp }}
                    }
                  </td>
                  <td>
                    <button type="button" class="btn btn-sm btn-danger" (click)="removeInput(i)" [disabled]="viewOnly">
                      <i class="bi bi-trash3"></i>
                    </button>
                  </td>
                </tr>
                }
              </tbody>
            </table>
          </div>
        </div>

        <!-- Right Side - Bulk Item Details -->
        @if (parentProduct) {
        <div class="col-md-4">
          <div class="card">
            <div class="card-header">
              <h6 class="mb-0">Parent Bulk Item Details</h6>
            </div>
            <div class="card-body">
              <div class="row mb-2">
                <div class="col-6"><strong>Bulk Code</strong></div>
                <div class="col-6">{{ selectedBulkItem?.bulkCode }}</div>
              </div>
              <div class="row mb-2">
                <div class="col-6"><strong>Bulk Item</strong></div>
                <div class="col-6">{{ selectedBulkItem?.bulkItem }}</div>
              </div>
              <div class="row mb-2">
                <div class="col-6"><strong>Cost Price</strong></div>
                <select class="form-select form-select-sm" [(ngModel)]="selectedBulkItem.costPrice"
                  [disabled]="viewOnly" (change)="onPriceChange('costPrice', $event)">
                  @for ( option of parentProduct.variants?.[0]?.pricing || []; track
                  option; let i = $index) {
                  <option [value]="option.costPrice" [attr.data-index]="i">
                    {{ option.costPrice }}
                  </option>
                  }
                </select>
              </div>
              <div class="row mb-2">
                <div class="col-6"><strong>Selling Price</strong></div>
                <select class="form-select form-select-sm" [(ngModel)]="selectedBulkItem.sellingPrice"
                  [disabled]="viewOnly" (change)="onPriceChange('sellingPrice', $event)">
                  @for ( option of parentProduct.variants?.[0]?.pricing || []; track
                  option; let i = $index) {
                  <option [value]="option.sellingPrice" [attr.data-index]="i">
                    {{ option.sellingPrice }}
                  </option>
                  }
                </select>
              </div>
              <div class="row mb-2">
                <div class="col-6"><strong>MRP</strong></div>
                <select class="form-select form-select-sm" [(ngModel)]="selectedBulkItem.mrp" [disabled]="viewOnly"
                  (change)="onPriceChange('mrp', $event)">
                  @for ( option of parentProduct.variants?.[0]?.pricing || []; track
                  option; let i = $index) {
                  <option [value]="option.mrp" [attr.data-index]="i">
                    {{ option.mrp }}
                  </option>
                  }
                </select>
              </div>
              <div class="row mb-2">
                <div class="col-6"><strong>Current Stock</strong></div>
                <div class="col-6 text-primary">
                  {{ selectedBulkItem?.currentStock | number : "1.3-3" }} Kg
                </div>
              </div>
              <div class="row mb-2">
                <div class="col-6"><strong>Packed</strong></div>
                <div class="col-6 text-primary">
                  {{ selectedBulkItem?.packed | number : "1.2-2" }} Kg
                </div>
              </div>
              <div class="row mb-2">
                <div class="col-6"><strong>Wastage</strong></div>
                <div class="col-6 text-danger">
                  {{ wastageKg | number : "1.3-3" }} Kg
                </div>
              </div>
              <div class="row mb-2">
                <div class="col-6"><strong>Avail for pack</strong></div>
                <div class="col-6"
                  [ngClass]="(selectedBulkItem?.availForPack ?? 0) < 0 ? 'text-danger fw-bold' : 'text-primary'">
                  {{ selectedBulkItem?.availForPack | number : "1.3-3" }} Kg
                  @if ((selectedBulkItem?.availForPack ?? 0) < 0) {
                  <small class="d-block fw-normal">Stock will go negative after posting</small>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
        }
      </div>

      <!-- Submit Button -->
      <div class="mt-4 text-end">
        @if (!viewOnly) {
        <button type="submit" class="btn btn-success" (click)="saveRepack()">
          @if (repackForm.pending) {
          <span class="spinner-border spinner-border-sm me-2"></span>
          }
          {{ isEdit ? "Update" : "Create" }}
        </button>
        }
      </div>
    </div>
  </div>

  <!-- New Pricing Modal (child product: add new MRP + Selling Price) -->
  @if (isPricingFormVisible && !viewOnly) {
  <div class="modal d-block" tabindex="-1" style="background: rgba(0,0,0,0.4)">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            Add New Pricing
            <span class="badge bg-info text-dark ms-2">
              SKU: {{ editingChild?.sku || "N/A" }}
            </span>
          </h5>
          <button type="button" class="btn-close" (click)="isPricingFormVisible = false" aria-label="Close"></button>
        </div>
        <form #repackPricingForm="ngForm">
          @if (newPricingValidationError) {
          <div class="px-3 pt-3">
            <div class="alert alert-danger py-2 mb-0" role="alert">
              <i class="bi bi-exclamation-triangle-fill me-2"></i>
              <strong>Pricing Validation:</strong> {{ newPricingValidationError }}
            </div>
          </div>
          }
          <div class="modal-body">
            <div class="row">
              <div class="col-md-6 mb-3">
                <label class="form-label text-dark">Base Price (ACP)</label>
                <input type="number" class="form-control" [value]="editingChildAcp" readonly />
                <small class="text-muted">Same as current</small>
              </div>
              <div class="col-md-6 mb-3">
                <label class="form-label text-dark">Cost Price (CP)</label>
                <input type="number" class="form-control" [value]="editingChildCp" readonly />
                <small class="text-muted">Same as current</small>
              </div>
              <div class="col-md-6 mb-3">
                <label class="form-label text-dark">Selling Price <span class="text-danger">*</span></label>
                <input type="number" class="form-control" [(ngModel)]="newPricing.sellingPrice" name="sellingPrice"
                  required (ngModelChange)="validateNewPricing()" />
              </div>
              <div class="col-md-6 mb-3">
                <label class="form-label text-dark">MRP <span class="text-danger">*</span></label>
                <input type="number" class="form-control" [(ngModel)]="newPricing.mrp" name="mrp" required
                  (ngModelChange)="validateNewPricing()" />
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" (click)="isPricingFormVisible = false">
              Cancel
            </button>
            <button type="button" class="btn btn-primary" (click)="saveNewPricing()"
              [disabled]="newPricingValidationError !== null || !newPricing.mrp || !newPricing.sellingPrice">
              Save Pricing
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
  }
</div>